import tuner from '../tuner';

/**
 * @module baseState
 */
export default {
  name: 'base',
  enter: function () {},
  exit: function () {},
  play: function () {},
  playBoostExperience: function () {},
  pause: function () {},
  stop: function () {},
  seek: function () {},
  load: function (promise) {
    tuner.changeState(tuner.states.loading, promise);
  },
};
